import {
  CouponInfoSheet,
  WalletCoupon,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import React from 'react';
import styled from 'styled-components';
import {getCouponPromotionId} from '../../getCouponPromotionId';
import {CouponCardWithLink} from './CouponCardWithLink';

export const CouponWalletCouponsStream: React.FC<{
  coupons: WalletCoupon[];
  enableEmptyDisabledView?: boolean;
  setSelectedProduct?: (product: Product | undefined) => void;
  stateManagerCustomKey: string;
  handleInfoIconClick: (couponInfo?: CouponInfoSheet) => void;
  paused?: boolean;
}> = ({
  coupons,
  enableEmptyDisabledView,
  setSelectedProduct,
  stateManagerCustomKey,
  handleInfoIconClick,
  paused,
}) => (
  <CouponsContainer
    data-testid="couponWalletCouponsStream"
    data-paused={paused}
  >
    {coupons.map(coupon => (
      <CouponCardWithLink
        key={`CouponWalletCoupon-${getCouponPromotionId(coupon.coupon)}`}
        coupon={coupon}
        handleInfoIconClick={handleInfoIconClick}
        enableEmptyDisabledView={enableEmptyDisabledView}
        setSelectedProduct={setSelectedProduct}
        stateManagerCustomKey={stateManagerCustomKey}
      />
    ))}
  </CouponsContainer>
);

const CouponsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 0 100px;
  width: 100%;
  &[data-paused='true'] {
    opacity: 0.6;
    pointer-events: none;
  }
`;
